import { ConfigConstants } from '@evorait/pace-core';
import NotificationTypes = ConfigConstants.NotificationTypes;

export type DocumentState = Readonly<{
    docBoxId: string;
    docType: string;
    title: string;
    date: string | null;
    createdBy: string;
    fileType: string;
    isFileVisible: boolean;
    orderNumber: string;
    printNumber: string;
    reportStatus?: DocBoxReportStatus;
    isFileSelected?: boolean;
    funcLoc: string;
    serialNo: string;
    material: string;
    equipment: string;
    notification: string;
    notificationType: ConfigConstants.NotificationTypes;
    language: string;
    description: string;
    taskNumber?: string;
    paperworkUpload?: boolean;
    sapID?: string;
}>;

export type DocumentStateUpload = Readonly<
    Omit<DocumentState, 'docBoxId' | 'createdBy' | 'isFileSelected' | 'fileType'> & {
        file: File | undefined;
        protectionClass: 'restricted' | 'unrestricted';
        equipment: string;
        filePrefix?: string;
    }
>;

export type DocumentFormStateUpload = Readonly<
    Omit<DocumentState, 'docBoxId' | 'createdBy' | 'isFileSelected' | 'fileType'> & {
        file: File | undefined;
        protectionClass: 'Internal' | 'Customer visible';
    }
>;

export const initialDocumentState: DocumentState = {
    docBoxId: '',
    docType: '',
    title: '',
    date: '',
    createdBy: '',
    fileType: '',
    isFileVisible: true,
    orderNumber: '',
    printNumber: '',
    isFileSelected: false,
    funcLoc: '',
    serialNo: '',
    material: '',
    equipment: '',
    notification: '',
    notificationType: NotificationTypes.Unknown,
    language: '',
    description: '',
};

export enum DOCUMENT_FILTERS {
    'docType' = 'docType',
    'title' = 'title',
    'printNumber' = 'printNumber',
    'date' = 'date',
    'createdBy' = 'createdBy',
    'orderNumber' = 'orderNumber',
    'reportStatus' = 'reportStatus',
    'fileType' = 'fileType',
}

export enum DocBoxReportStatus {
    INTERIM = 'I',
    FINAL = 'F',
}
